import * as React from 'react';
import { Route } from 'react-router-dom';

import PwrSendMailEnd from '../containers/PwrSendMailEnd';
import ChangePassword from '../pages/ChangePassword';
import ELearning from '../pages/ELearning';
import ELearningPortal from '../pages/ELearningPortal';
import ELearningPreview from '../pages/ELearningPreview';
import CMHelpParticipant from '../pages/help/CMParticipant';
import HelpParticipant from '../pages/help/Participant';
import Login from '../pages/Login';
import LoginSso from '../pages/LoginSso';
import LoginSsosp from '../pages/LoginSsosp';
import Logout from '../pages/Logout';
import PersonalActResultApplication from '../pages/personal/ActResultApplication';
import PersonalActResultReference from '../pages/personal/ActResultReference';
import PersonalApplicationCancel from '../pages/personal/ApplicationCancel';
import PersonalApplicationChange from '../pages/personal/ApplicationChange';
import PersonalApplicationStatus from '../pages/personal/ApplicationStatus';
import ApprovalChange from '../pages/personal/ApprovalsChange';
import PersonalAssessmentForm from '../pages/personal/AssessmentForm';
import PersonalAssessmentFormPortal from '../pages/personal/AssessmentFormPortal';
import PersonalAssessmentResult from '../pages/personal/AssessmentResult';
import AdminAssessmentResult from '../pages/personal/AssessmentResultAdmin';
import PersonalCareerDetail from '../pages/personal/CareerDetail';
import PersonalCourseDetail from '../pages/personal/CourseDetail';
import PersonalCurriculumAchieveCondition from '../pages/personal/CurriculumAchieveCondition';
import PersonalCurriculumContent from '../pages/personal/CurriculumContent';
import PersonalCurriculumDetail from '../pages/personal/CurriculumDetail';
import PersonalExercise from '../pages/personal/Exercise';
import PersonalExerciseForm from '../pages/personal/ExerciseForm';
import PersonalExerciseFormPortal from '../pages/personal/ExerciseFormPortal';
import PersonalLectureApplication from '../pages/personal/LectureApplication';
import PersonalLectureCancel from '../pages/personal/LectureCancel';
import PersonalMessageDetail from '../pages/personal/MessageDetail';
import PersonalPortal from '../pages/personal/Portal';
import PersonalProcessStatus from '../pages/personal/ProcessStatus';
import AdminProcessStatus from '../pages/personal/ProcessStatusAdmin';
import PersonalProfile from '../pages/personal/Profile';
import PersonalQuestionnaire from '../pages/personal/Questionnaire';
import PersonalQuestionnaireForm from '../pages/personal/QuestionnaireForm';
import PersonalQuestionnaireFormPortal from '../pages/personal/QuestionnaireFormPortal';
import PersonalQuickModeOrgUserRegisterMain from '../pages/personal/QuickModeOrgUserRegisterMain';
import PersonalSearch from '../pages/personal/Search';
import PersonalSkill from '../pages/personal/Skill';
import PersonalSkillAdminView from '../pages/personal/SkillAdminView';
import SkillDetail from '../pages/personal/SkillDetail';
import PersonalSkillMap from '../pages/personal/SkillMap';
import AdminSkillMap from '../pages/personal/SkillMapAdmin';
import SkillMapDetail from '../pages/personal/SkillMapDetail';
import PersonalStatus from '../pages/personal/Status';
import PersonalTestQuestionnaireHistory from '../pages/personal/TestQuestionnaireHistory';
import PersonalTestResult from '../pages/personal/TestResult';
import PersonalWhatsNewDetail from '../pages/personal/WhatsNewDetail';
import PwrChangePassword from '../pages/pwr/PasswordChange';
import PwrChangePasswordEnd from '../pages/pwr/PasswordChangeEnd';
import PersonalQuickMode from '../pages/quickMode/QuickMode';
import QuickModeContentsCreate from '../pages/quickMode/QuickModeContentsCreate';
import QuickModeContentsPreview from '../pages/quickMode/QuickModeContentsPreview';
import QuickModeTextAndTestCreate from '../pages/quickMode/QuickModeTextAndTestCreate';
import QuickModeStudentAssign from '../pages/quickMode/StudentAssign';
import Config from '../site.config.json';

// 画面をあらわすenum
enum Screens {
	LOGIN,
	LOGINSSO,
	LOGINSSOSP,
	LOGOUT,
	CHANGE_PASSWORD,
	PERSONAL_PORTAL,
	PERSONAL_MESSAGE_DETAIL,
	PERSONAL_WHATS_NEW_DETAIL,
	PERSONAL_SEARCH,
	PERSONAL_STATUS,
	PERSONAL_SKILL,
	PERSONAL_SKIll_ADMIN_VIEW,
	PERSONAL_SKILL_MAP,
	PERSONAL_PROFILE,
	PERSONAL_EXERCISE,
	PERSONAL_EXERCISE_FORM,
	PERSONAL_APPLICATION_STATUS,
	PERSONAL_APPLICATION_CANCEL,
	PERSONAL_APPLICATION_CHANGE,
	PERSONAL_CAREER_DETAIL,
	PERSONAL_CLASS_APPROVALS_CHANGE,
	PERSONAL_COURSE_DETAIL,
	PERSONAL_CURRICULUM_ACHIEVE_CONDITION,
	PERSONAL_CURRICULUM_CONTENT,
	PERSONAL_CURRICULUM_DETAIL,
	PERSONAL_ACT_RESULT_APPLICATION,
	PERSONAL_ACT_RESULT_REFERENCE,
	PERSONAL_LECTURE_APPLICATION,
	PERSONAL_LECTURE_CANCEL,
	PERSONAL_TEST_QUESTIONNAIRE_HISTORY,
	PERSONAL_TEST_RESULT,
	PERSONAL_QUESTIONNAIRE,
	PERSONAL_QUESTIONNAIRE_FORM,
	PERSONAL_SKILL_DETAIL,
	PERSONAL_ASSESSMENT_RESULT,
	HELP_PARTICIPANT,
	HELP_PARTICIPANT_CM,
	ELEARNING,
	ELEARNING_PREVIEW,
	PWR_CHANGEPASSWORD,
	PWR_CHANGEPASSWORDEND,
	PWR_SENDMAILEND,
	PERSONAL_SKILL_MAP_DETAIL,
	PERSONAL_ASSESSMENT_FORM,
	PERSONAL_PROCESS_STATUS,
	ADMIN_PROCESS_STATUS,
	ADMIN_SKILL_MAP,
	ADMIN_ASSESSMENT_RESULT,
	QUICK_MODE,
	QUICK_MODE_CONTENTS_CREATE,
	QUICKMODE_STUDENT_ASSIGN,
	QUICK_MODE_TEXT_TEST_CREATE,
	QUICK_MODE_PREVIEW,
	QUICK_MODE_ORG_USER_REGISTER_MAIN,
	ELEARNING_PORTAL,
	PERSONAL_EXERCISE_FORM_PORTAL,
	PERSONAL_QUESTIONNAIRE_FORM_PORTAL,
	PERSONAL_ASSESSMENT_FORM_PORTAL,
}

// Symbol → path
const paths: Array<[Screens, string]> = [
	[Screens.LOGIN, '/login'],
	[Screens.LOGINSSO, '/loginsso'],
	[Screens.LOGINSSOSP, '/loginssosp'],
	[Screens.LOGOUT, '/logout'],
	[Screens.CHANGE_PASSWORD, '/password'],
	[Screens.PERSONAL_PORTAL, '/personal/portal'],
	[Screens.PERSONAL_MESSAGE_DETAIL, '/personal/message'],
	[Screens.PERSONAL_WHATS_NEW_DETAIL, '/personal/whatsnew'],
	[Screens.PERSONAL_SEARCH, '/personal/search'],
	[Screens.PERSONAL_STATUS, '/personal/status'],
	[Screens.PERSONAL_SKILL, '/personal/skill'],
	[Screens.PERSONAL_SKIll_ADMIN_VIEW, '/personal/skill/:user_id'],
	[Screens.PERSONAL_SKILL_MAP, '/personal/skillmap/:cmid'],
	[Screens.ADMIN_SKILL_MAP, '/admin/skillmap/:user_id/:cmid'],
	[Screens.PERSONAL_PROFILE, '/personal/profile'],
	[Screens.PERSONAL_EXERCISE, '/personal/exercise/:career_id/:class_id'],
	[
		Screens.PERSONAL_EXERCISE_FORM,
		'/personal/exercise/:career_id/:class_id/:seq/:flg/:subjectStatusflg',
	],
	[
		Screens.PERSONAL_APPLICATION_STATUS,
		'/personal/application/status/:career_id/:class_id/:apl_type/:curriculum_flg',
	],
	[
		Screens.PERSONAL_APPLICATION_CANCEL,
		'/personal/application/cancel/:career_id/:class_id/:apl_type',
	],
	[
		Screens.PERSONAL_APPLICATION_CHANGE,
		'/personal/application/change/:career_id/:career_typeid/:class_id',
	],
	[Screens.PERSONAL_CAREER_DETAIL, '/personal/career/detail/:career_id'],
	[Screens.PERSONAL_COURSE_DETAIL, '/personal/course/detail/:career_id'],
	[
		Screens.PERSONAL_CURRICULUM_ACHIEVE_CONDITION,
		'/personal/curriculum/achievecond/:curriculum_id',
	],
	[
		Screens.PERSONAL_CURRICULUM_CONTENT,
		'/personal/curriculum/content/:career_id/:cur_type',
	],
	[
		Screens.PERSONAL_CURRICULUM_DETAIL,
		'/personal/curriculum/detail/:curriculum_id',
	],
	[Screens.PERSONAL_LECTURE_APPLICATION, '/personal/lecture/application'],
	[
		Screens.PERSONAL_LECTURE_CANCEL,
		'/personal/lecture/cancel/:career_id/:class_id/:curriculum_flg',
	],
	[
		Screens.PERSONAL_ACT_RESULT_APPLICATION,
		'/personal/actresult/application/:career_id/:class_id/:nittei_only_flg',
	],
	[
		Screens.PERSONAL_ACT_RESULT_REFERENCE,
		'/personal/actresult/reference/:career_id/:class_id/:seq',
	],
	[
		Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY,
		'/personal/test/history/:career_id/:class_id',
	],
	[
		Screens.PERSONAL_TEST_RESULT,
		'/personal/test/result/:career_id/:class_id/:test_id/:thistory_id/:display_style',
	],
	[
		Screens.PERSONAL_QUESTIONNAIRE,
		'/personal/questionnaire/:career_id/:class_id',
	],
	[
		Screens.PERSONAL_QUESTIONNAIRE_FORM,
		'/personal/questionnaire/:career_id/:class_id/:questionnaire_id/:type/:flg',
	],
	[Screens.HELP_PARTICIPANT, '/help/participant'],
	[Screens.HELP_PARTICIPANT_CM, '/help/CMParticipant'],
	[Screens.ELEARNING, '/elearning/:career_id/:class_id'],
	[Screens.ELEARNING_PREVIEW, '/preview/:career_id/:class_id/:window_id'],
	[Screens.PERSONAL_CLASS_APPROVALS_CHANGE, '/personal/approvals/change'],
	[Screens.PWR_CHANGEPASSWORD, '/pwr/PasswordChange/:authKey'],
	[Screens.PWR_CHANGEPASSWORDEND, '/pwr/PasswordChangeEnd'],
	[Screens.PWR_SENDMAILEND, '/containers/PwrSendMailEnd'],
	[Screens.PERSONAL_SKILL_DETAIL, '/personal/skill/detail/:skill_id'],
	[
		Screens.PERSONAL_ASSESSMENT_RESULT,
		'/personal/skill/assessment/:career_id/:class_id/:rank_id',
	],
	[
		Screens.ADMIN_ASSESSMENT_RESULT,
		'/admin/skill/assessment/:user_id/:career_id/:class_id/:rank_id',
	],
	[
		Screens.PERSONAL_SKILL_MAP_DETAIL,
		'/personal/skillmap/detail/:skill_map_id',
	],
	[
		Screens.PERSONAL_ASSESSMENT_FORM,
		'/personal/questionnaire/:career_id/:class_id/:questionnaire_id/:type',
	],
	[Screens.PERSONAL_PROCESS_STATUS, '/personal/processStatus/:skill_map_id'],
	[
		Screens.ADMIN_PROCESS_STATUS,
		'/admin/processStatus/:user_id/:skill_map_id',
	],
	[Screens.QUICK_MODE, '/personal/quickMode'],
	[Screens.QUICK_MODE_CONTENTS_CREATE, '/personal/contentsCreate'],
	[Screens.QUICKMODE_STUDENT_ASSIGN, '/quickMode/studentAssign'],
	[Screens.QUICK_MODE_TEXT_TEST_CREATE, '/personal/textAndTestCreate'],
	[Screens.QUICK_MODE_PREVIEW, '/personal/contenspreview'],
	[
		Screens.QUICK_MODE_ORG_USER_REGISTER_MAIN,
		'/personal/quick_mode_org_user_register_main',
	],
	[Screens.ELEARNING_PORTAL, '/elearning/portal/:career_id/:class_id'],
	[
		Screens.PERSONAL_EXERCISE_FORM_PORTAL,
		'/personal/portal/exercise/:career_id/:class_id/:seq/:flg/:subjectStatusflg',
	],
	[
		Screens.PERSONAL_QUESTIONNAIRE_FORM_PORTAL,
		'/personal/portal/questionnaire/:career_id/:class_id/:questionnaire_id/:type/:flg',
	],
	[
		Screens.PERSONAL_ASSESSMENT_FORM_PORTAL,
		'/personal/portal/assessment/:career_id/:class_id/:questionnaire_id/:type/:flg',
	],
];

// Symbol → component
const components: Array<[Screens, React.ComponentType<any>]> = [
	[Screens.LOGIN, Login],
	[Screens.LOGINSSO, LoginSso],
	[Screens.LOGINSSOSP, LoginSsosp],
	[Screens.LOGOUT, Logout],
	[Screens.CHANGE_PASSWORD, ChangePassword],
	[Screens.PERSONAL_PORTAL, PersonalPortal],
	[
		Screens.QUICK_MODE_ORG_USER_REGISTER_MAIN,
		PersonalQuickModeOrgUserRegisterMain,
	],
	[Screens.PERSONAL_MESSAGE_DETAIL, PersonalMessageDetail],
	[Screens.PERSONAL_WHATS_NEW_DETAIL, PersonalWhatsNewDetail],
	[Screens.PERSONAL_SEARCH, PersonalSearch],
	[Screens.PERSONAL_STATUS, PersonalStatus],
	[Screens.PERSONAL_SKILL, PersonalSkill],
	[Screens.PERSONAL_SKIll_ADMIN_VIEW, PersonalSkillAdminView],
	[Screens.PERSONAL_SKILL_MAP, PersonalSkillMap],
	[Screens.ADMIN_SKILL_MAP, AdminSkillMap],
	[Screens.PERSONAL_PROFILE, PersonalProfile],
	[Screens.QUICK_MODE, PersonalQuickMode],
	[Screens.QUICK_MODE_CONTENTS_CREATE, QuickModeContentsCreate],
	[Screens.QUICK_MODE_TEXT_TEST_CREATE, QuickModeTextAndTestCreate],
	[Screens.PERSONAL_EXERCISE, PersonalExercise],
	[Screens.PERSONAL_EXERCISE_FORM, PersonalExerciseForm],
	[Screens.PERSONAL_APPLICATION_STATUS, PersonalApplicationStatus],
	[Screens.PERSONAL_APPLICATION_CANCEL, PersonalApplicationCancel],
	[Screens.PERSONAL_APPLICATION_CHANGE, PersonalApplicationChange],
	[Screens.PERSONAL_CAREER_DETAIL, PersonalCareerDetail],
	[Screens.PERSONAL_COURSE_DETAIL, PersonalCourseDetail],
	[
		Screens.PERSONAL_CURRICULUM_ACHIEVE_CONDITION,
		PersonalCurriculumAchieveCondition,
	],
	[Screens.PERSONAL_CURRICULUM_CONTENT, PersonalCurriculumContent],
	[Screens.PERSONAL_CURRICULUM_DETAIL, PersonalCurriculumDetail],
	[Screens.PERSONAL_LECTURE_APPLICATION, PersonalLectureApplication],
	[Screens.PERSONAL_LECTURE_CANCEL, PersonalLectureCancel],
	[Screens.PERSONAL_ACT_RESULT_APPLICATION, PersonalActResultApplication],
	[Screens.PERSONAL_ACT_RESULT_REFERENCE, PersonalActResultReference],
	[
		Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY,
		PersonalTestQuestionnaireHistory,
	],
	[Screens.PERSONAL_TEST_RESULT, PersonalTestResult],
	[Screens.PERSONAL_QUESTIONNAIRE, PersonalQuestionnaire],
	[Screens.PERSONAL_QUESTIONNAIRE_FORM, PersonalQuestionnaireForm],
	[Screens.HELP_PARTICIPANT, HelpParticipant],
	[Screens.HELP_PARTICIPANT_CM, CMHelpParticipant],
	[Screens.ELEARNING, ELearning],
	[Screens.ELEARNING_PREVIEW, ELearningPreview],
	[Screens.PERSONAL_CLASS_APPROVALS_CHANGE, ApprovalChange],
	[Screens.PWR_CHANGEPASSWORD, PwrChangePassword],
	[Screens.PWR_CHANGEPASSWORDEND, PwrChangePasswordEnd],
	[Screens.PWR_SENDMAILEND, PwrSendMailEnd],
	[Screens.PERSONAL_SKILL_DETAIL, SkillDetail],
	[Screens.PERSONAL_ASSESSMENT_RESULT, PersonalAssessmentResult],
	[Screens.ADMIN_ASSESSMENT_RESULT, AdminAssessmentResult],
	[Screens.PERSONAL_SKILL_MAP_DETAIL, SkillMapDetail],
	[Screens.PERSONAL_ASSESSMENT_FORM, PersonalAssessmentForm],
	[Screens.PERSONAL_PROCESS_STATUS, PersonalProcessStatus],
	[Screens.ADMIN_PROCESS_STATUS, AdminProcessStatus],
	[Screens.QUICK_MODE_PREVIEW, QuickModeContentsPreview],
	[Screens.QUICKMODE_STUDENT_ASSIGN, QuickModeStudentAssign],
	[Screens.ELEARNING_PORTAL, ELearningPortal],
	[Screens.PERSONAL_EXERCISE_FORM_PORTAL, PersonalExerciseFormPortal],
	[Screens.PERSONAL_ASSESSMENT_FORM_PORTAL, PersonalAssessmentFormPortal],
	[
		Screens.PERSONAL_QUESTIONNAIRE_FORM_PORTAL,
		PersonalQuestionnaireFormPortal,
	],
];

//

const pathMap = new Map(); // IEで new Map([iterable]) が非対応
paths.forEach(elem => {
	pathMap.set(elem[0], elem[1]);
});

class Routes {
	public static getPath(screen: Screens): string {
		const path = pathMap.get(screen);
		if (!path) {
			throw Error(`path for ${screen} not found`);
		}
		if (!Config.multiTenant) {
			return Config.topPath + path;
		}

		// 法人一意モード(マルチテナント)時のパス生成
		if (!window.location.pathname.startsWith(Config.topPath + '/')) {
			throw Error(
				`illegal pathname: ${
					window.location.pathname
				} doesnt start with ${Config.topPath + '/'}`
			);
		}
		const [, , companyCode] = window.location.pathname.split('/', 3);
		return Config.topPath + '/' + companyCode + path;
	}
}

const getRouterPath = (screen: Screens) => {
	const path = pathMap.get(screen);
	return Config.multiTenant
		? Config.topPath + '/:company_code' + path
		: Config.topPath + path;
};

const LearnBrowserRouter: React.FC<{}> = () => {
	const defaultPath = Config.multiTenant
		? Config.topPath + '/:company_code'
		: Config.topPath;
	return (
		<>
			<Route exact={true} path={defaultPath} component={Login} />
			{components.map((tuple: [Screens, React.ComponentType<any>]) => {
				const p = getRouterPath(tuple[0]);
				const c = tuple[1] as React.ComponentType<any>;
				return <Route key={p} exact={true} path={p} component={c} />;
			})}
		</>
	);
};

export { Screens, Routes, LearnBrowserRouter };



// WEBPACK FOOTER //
// ./src/utils/Routes.tsx